module.exports = __webpack_public_path__ + "static/media/icon_contrato_azul.d555a0dc.svg";